import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getBrowserLocale } from '@/i18n/locale';
import type { Locale } from '@/i18n/translations';

interface I18nState {
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

export const useI18nStore = create<I18nState>()(
  persist(
    (set) => ({
      locale: getBrowserLocale(),
      setLocale: (locale) => set({ locale }),
    }),
    {
      name: 'invest-locale',
      version: 1,
    }
  )
);
